import axios from "axios";
import {logout} from "@/plugins/users";

axios.defaults.baseURL = 'https://api.hefservice.com/api';

axios.defaults.withCredentials = true;

axios.defaults.headers['Cache-Control'] = 'no-store';

axios.interceptors.request.use((request) => {
  const token = localStorage.getItem("access");
  if (token) {
    request.headers.Authorization = `Bearer ${token}`;
  }
  return request;
});

axios.interceptors.response.use(function (response) {
  return response;
}, function (error) {
  if (error.response.status === 401) {
    logout()
  }
  return Promise.reject(error);
});
export default axios;
